import React from 'react';

import createIcon from './createIcon';

export default createIcon('0 0 24 24', <path xmlns="http://www.w3.org/2000/svg" d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />);
